import { ThinUploadModal } from "./ThinUploadModal";

export function UploadVendorQuoteModal({
  open, onOpenChange,
}: { open: boolean; onOpenChange: (v: boolean) => void }) {
  return (
    <ThinUploadModal
      open={open}
      onOpenChange={onOpenChange}
      title="Vendor Quote"
      entityType="vendor_quote"
      extractEndpoint="/vendor-quotes/extract"
      detailRoutePrefix="/vendor-quotes"
    />
  );
}
